import * as THREE from 'three'
import OrbitControls from 'three-orbitcontrols'

const smootRotate = (camera = THREE.PerspectiveCamera.prototype, controls: OrbitControls) => {
  // direction
  if( !camera.userData.verticalDirection ){
      camera.userData.verticalDirection = 1;
  }

  // min max Y positions
  if( !camera.userData.startPosition ){
    camera.userData.startPosition = camera.position.clone();
  }
  const minYAdd = 70;
  if( !camera.userData.minY ){
    camera.userData.minY = minYAdd;
  }
  const maxYAdd = 450;
  if( !camera.userData.maxY ){
    camera.userData.maxY = camera.userData.minY + maxYAdd;
  }

  // Y additional factor
  const yAdd = 0.3;
  if( !camera.userData.yAddFactor ){
    camera.userData.yAddFactor = yAdd;
  }

  const cameraMinimumY = camera.userData.startPosition.y + camera.userData.minY;
  const cameraMaximumY = camera.userData.startPosition.y + camera.userData.maxY;
  const cameraYRange = cameraMaximumY - cameraMinimumY;


  const nextYAdd = camera.userData.verticalDirection * camera.userData.yAddFactor;

  let nextCameraY = camera.position.y + nextYAdd;

  const yPositionAlpha = ( nextCameraY - cameraMinimumY ) / cameraYRange;
  let YposBySin = 1 - (0.5 + Math.cos( Math.PI * yPositionAlpha ) * 0.5);

  const Controls_XZ = new THREE.Vector2(  controls!.target.x, controls!.target.z );
  const Camera_XZ = new THREE.Vector2(  camera!.position.x, camera!.position.z );

  const dist = Controls_XZ.distanceTo( Camera_XZ );
  const angle = Math.atan2(  Controls_XZ.x - Camera_XZ.x, Controls_XZ.y - Camera_XZ.y );


  const rotationAsDegree = 0.15;
  const nextAngle = angle + Math.PI / 180 * rotationAsDegree;

  let finalYAdd;
  const minimumOfSpeed = 0.1;
  if( camera.userData.verticalDirection < 0 && yPositionAlpha < 0.01 ){
    finalYAdd = nextYAdd * YposBySin < minimumOfSpeed ? minimumOfSpeed : nextYAdd * YposBySin;
  } else if( camera.userData.verticalDirection > 0 && yPositionAlpha > 0.99 ) {
    finalYAdd = nextYAdd * YposBySin < minimumOfSpeed ? minimumOfSpeed : nextYAdd * YposBySin;
  } else {
    finalYAdd = nextYAdd;
  }


  camera.position.x =  Controls_XZ.x - dist * Math.sin( nextAngle );
  camera.position.y = camera.position.y + finalYAdd;
  camera.position.z = Controls_XZ.y - dist * Math.cos( nextAngle );

  if( camera.position.y >= cameraMaximumY ){
    camera.userData.verticalDirection = -1;
  } else if( camera.position.y <= cameraMinimumY ){
    camera.userData.verticalDirection = 1;
  }
}

export default smootRotate